import { PaymentDetailFragment } from 'generated/resources/graphql'

import MoneyWithCurrency from 'modules/core/lib/money'

interface PaymentWithExecutions<T> {
  paymentExecutions?: ReadonlyArray<T> | null
}

export const lastPaymentExecution = <T>(payment: PaymentWithExecutions<T>): T | undefined => {
  const executions = payment.paymentExecutions ?? []
  if (executions.length === 0) return undefined
  return executions[executions.length - 1]
}
const lastPaymentExecutionfromPaymentDetail = (payment: PaymentDetailFragment) => {
  const executions = payment.paymentExecutions ?? []
  if (executions.length === 0) return undefined
  return executions[executions.length - 1]
}

/**
 * Checks if the bank account supports SEPA payments
 * @param services - Array of services from providerConfiguration
 * @returns true if both 'payment_management' and 'sepa_payment_management' are present
 */
export const supportsSepaPayment = (services?: string[] | null): boolean => {
  const serviceList = services ?? []
  return (
    serviceList.includes('payment_management') && serviceList.includes('sepa_payment_management')
  )
}

/**
 * Determines if "Pay with SEPA transfer" action should be shown
 * @param status - Payment status
 * @param supportsSepa - Whether bank account supports SEPA payments
 * @param hasTransfers - Whether payment has transfers
 * @returns true if all conditions are met
 */
export const shouldShowPayWithSepaTransfer = (
  status: string,
  supportsSepa: boolean,
  hasTransfers: boolean
): boolean => {
  return status === 'init' && supportsSepa && hasTransfers
}

export const formattedAmount = ({
  amountCents,
  currency,
  locale,
  emptyValue = '',
}: {
  amountCents?: number | null
  currency?: string | null
  locale: string
  emptyValue?: string
}): string => {
  const upperCaseCurrency = currency?.toUpperCase()
  if (amountCents == null) {
    return emptyValue
  }
  return MoneyWithCurrency({
    amount: Math.round(amountCents || 0),
    currency: upperCaseCurrency,
    locale,
    emptyValue,
  })
}
